import {axiosApiCallWithToken} from "../axios/customInstance";

export const getMeasurementDateAndValue = async (
    userId,
    measurementDescription,
    priorDays,
) => {
    const url =
        "/measurement/data/days?userId=" +
        userId +
        "&measurementDescription=" +
        measurementDescription +
        "&days=" +
        priorDays;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getAllMeasurement = async () => {
    const url = "/measurementService";

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getMeasurementData = async (userId, measurementId) => {
    const url =
        "/patients/measurement/user?userId=" +
        userId +
        "&measurementId=" +
        measurementId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};


export const getMeasurementDataByMeasurementDate = async (userId, measurementId, startDate='1900-01-01', endDate='9999-12-31') => {
    const url =
        "/patients/measurement_data_by_measurement_date?userId=" +
        userId +
        "&measurementId=" +
        measurementId +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate;


    const response = await axiosApiCallWithToken.get(url);
    return response.data;

};

export const getMeasurementDataByDate = async (userId, measurementId, startDate) => {
    const url =
        "measurement/date?userId=" +
        userId +
        "&measurementId=" +
        measurementId +
        "&startDate=" +
        startDate;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getThresholdData = async (userId, measurementId) => {
    const url =
        "/measurement/threshold?userId=" +
        userId +
        "&measurementId=" +
        measurementId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        console.log("THRESHOLD", response.data);
        return response.data;
    } catch (error) {
        console.log(error);
        return {
            lowerThreshold: undefined,
            upperThreshold: undefined,
        };
        //throw error;
    }
};

export const getRiskFactor = async (userId, date) => {
    const url = "/user/risk-factor?userId=" + userId + "&date=" +
        date;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getTeeValue = async (userId) => {
    const url = "/user/tee?userId=" + userId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getPalValue = async (userId) => {
    const url = "/user/pal?userId=" + userId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getSingleQuestionnaireScore = async (userId, questionnaireId) => {
    const url = "/user/questionnaire-score?userId=" + userId + '&questionnaireId=' + questionnaireId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        console.log("RESPONSE QUESTIONNAIRE", response.data)
        if (response.data.length > 0)
            return response.data[0].score
        else
            return undefined
    } catch (err) {
        console.error(err);
        throw err;
    }
}


export const getQuestionnaireScores = async (userId) => {
    const url = "/user/questionnaire-scores?userId=" + userId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        console.log("QUESTIONNAIRES RESULT", response.data)
        if (response.data.length > 0)
            return response.data
        else
            return undefined
    } catch (err) {
        console.error(err);
        throw err;
    }
}

export const getBmiValue = async (userId) => {
    const url = "/user/bmi-value?userId=" + userId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getHarrisBenedict = async (userId) => {
    const url = "/user/harris-benedict?userId=" + userId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getInitialAnamnesis = async (userId) => {
    const url = "/user/anamnesis-options?userId=" + userId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getTherapiesData = async (userId) => {
    const url = "/user/therapies?userId=" + userId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getDrugIntakeLogs = async (userId) => {
    const url = "/user/intake_logs?userId=" + userId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const getPathologies = async (userId) => {
    const url = "/user/pathologies?userId=" + userId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};


export const getBloodPressureMood = async (userId) => {
    const url = "/patients/mood_events?userId=" + userId;

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const updateThresholdValue = async (userId, lowerThreshold, upperThreshold) => {
    const url = "/update_threshold_data?" +
        "userId=" + userId +
        "&lower_threshold=" + lowerThreshold +
        "&upper_threshold=" + upperThreshold;

    try {
        console.log(url)
        return await axiosApiCallWithToken.put(url);
    } catch (error) {
        console.log(error);
        throw error;
    }
};
// other async method to manage measurement
// export const postMeasurementValue = async (userId) => {}
